import React from 'react';
import { content, SupportedLocale } from '../lib/content';

type ForWhomProps = {
  locale?: SupportedLocale;
};

export const ForWhom: React.FC<ForWhomProps> = ({ locale = 'pl' }) => {
  const t = content[locale].forWhom;

  return (
    <section id={t.id} className="forwhom reveal">
      <div className="container">
        <div className="section-heading">
          <h2>{t.title}</h2>
        </div>
        <p className="section-intro">{t.intro}</p>
        <div className="forwhom-grid">
          {t.cards.map((card) => (
            <div className="card forwhom-card" key={card.title}>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
        <div className="forwhom-cta">
          <a className="inline-link" href="#kontakt">
            {t.linkText}
          </a>
        </div>
      </div>
    </section>
  );
};
